export default "__VITE_ASSET__DTeaPAqO__"